import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const IconLink = styled(NavLink)`
  display: block;
  padding: 24px 6px;
  ${TYPOGRAPHY.caption}
  color: ${COLORS.gray60};
  text-decoration: none;
  transition: color 0.25s ease-out;

  &.active,
  &:hover,
  &:focus {
    color: #fff;
  }
`;

export default IconLink;
